import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  FormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AlertifyService } from 'src/app/services/alertify.service';
import { ConfiguracionService } from 'src/app/services/configuracion.service';


@Component({
  selector: 'app-configuracion-global',
  templateUrl: './configuracion-global.component.html',
  styleUrls: ['./configuracion-global.component.scss']
})
export class ConfiguracionGlobalComponent implements OnInit {

  isLoadingResults = false;
  perfilFormGroup: UntypedFormGroup;
  configuracionFormGroup: UntypedFormGroup;
  public fotoPerfil = '../../../../assets/images/sinFoto.png';
  fileToUpload: File | null = null;
  cambioImg = false;

  constructor(
    private alertify: AlertifyService,
    private _formBuilder: UntypedFormBuilder,
    private configSvc: ConfiguracionService,
    public router: Router
  ) {}

  ngOnInit() {
    this.perfilFormGroup = this._formBuilder.group({
      diasPeriodoGracia: ['',  [Validators.required, Validators.min(0),Validators.pattern('^[0-9]+$')] ],
      minutosIngresosPrevioEntreno: ['',  [Validators.required, Validators.min(0),Validators.pattern('^[0-9]+$')] ],
      tiempoReusoCodigo:['',  [Validators.required, Validators.min(1),Validators.pattern('^[0-9]+$')] ],
      ingresoSinRestriccionDeHorarios: ['',  [Validators.required] ],
      aceptaOrdenAutomatica: ['',  [Validators.required] ],
      permiteDeudaSaldo: ['',  [Validators.required] ],
      permiteOrdenSinFoto: ['',  [Validators.required] ],
      permiteOrdenSinHorarios: ['',  [Validators.required] ],
    });

    this.getDataEmpresa();
  }

  getDataEmpresa(): void {
    this.configSvc.getDatosConfig().subscribe(
      (result) => {
        console.log(result);
          this.perfilFormGroup.get('diasPeriodoGracia')?.setValue(result.diasPeriodoGracia);
          this.perfilFormGroup.get('minutosIngresosPrevioEntreno')?.setValue(result.minutosIngresosPrevioEntreno);
          this.perfilFormGroup.get('ingresoSinRestriccionDeHorarios')?.setValue(result.ingresoSinRestriccionDeHorarios);
          this.perfilFormGroup.get('aceptaOrdenAutomatica')?.setValue(result.aceptaOrdenAutomatica);
          this.perfilFormGroup.get('tiempoReusoCodigo')?.setValue(result.tiempoReusoCodigo);
          this.perfilFormGroup.get('permiteDeudaSaldo')?.setValue(result.permiteDeudaSaldo);
          this.perfilFormGroup.get('permiteOrdenSinFoto')?.setValue(result.permiteOrdenSinFoto);
          this.perfilFormGroup.get('permiteOrdenSinHorarios')?.setValue(result.permiteOrdenSinHorarios);
      },
      (error) => {
        console.log(error);
        this.alertify.error(
          'Ha ocurrido un error al cargar la configuración. Intentelo de nuevo.'
        );
      //  this.router.navigate(['/in']);
      }
    );
  }

  /* Actualizacion del perfil de la empresa luego de Finalizar el Formulario */
  actualizar() {
    //Objeto con los datos del perfil de la empresa
    let config = this.perfilFormGroup.value;

    this.configSvc.guardarDatosConfig(config).subscribe(
      (result) => {
        console.log(result);
        if (result) {
          this.alertify.success('La actualización ha sido exitosa.');
        } else {
          this.alertify.error(
            'Ha ocurrido un error al actualizar. Intentelo de nuevo.'
          );
        }
      },
      (error) => {
        console.log(error);
        this.alertify.error(
          'Ha ocurrido un error al actualizar. Intentelo de nuevo.'
        );
      }
    );
  }

}
